var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6557 2.34533C12.9157 1.58935 12.0331 0.987641 11.0591 0.575027C10.085 0.162413 9.03872 -0.052911 7.98086 -0.0584828C6.923 -0.0640546 5.87454 0.140236 4.89616 0.542567C3.91778 0.944897 3.02891 1.53728 2.281 2.28542C1.53308 3.03357 0.940977 3.92262 0.538947 4.90112C0.136917 5.87962 -0.067052 6.92814 -0.061155 7.986C-0.0552579 9.04386 0.160388 10.09 0.573302 11.064C0.986216 12.038 1.5882 12.9204 2.34441 13.6601C3.85037 15.1333 5.87665 15.953 7.98332 15.9413C10.09 15.9295 12.107 15.0873 13.5965 13.5974C15.0859 12.1075 15.9275 10.0902 15.9386 7.98354C15.9497 5.87686 15.1294 3.85084 13.6557 2.34533ZM9.04354 11.4792C9.04354 11.756 8.93361 12.0214 8.73792 12.2171C8.54223 12.4128 8.27681 12.5227 8.00006 12.5227C7.72332 12.5227 7.4579 12.4128 7.26221 12.2171C7.06652 12.0214 6.95659 11.756 6.95659 11.4792V7.30533C6.95659 7.02858 7.06652 6.76317 7.26221 6.56748C7.4579 6.37179 7.72332 6.26185 8.00006 6.26185C8.27681 6.26185 8.54223 6.37179 8.73792 6.56748C8.93361 6.76317 9.04354 7.02858 9.04354 7.30533V11.4792ZM7.98267 5.52098C7.38093 5.52098 6.98093 5.09664 6.99137 4.57142C6.98093 4.01838 7.38093 3.60794 7.99311 3.60794C8.60876 3.60794 8.99485 4.01838 9.00876 4.57142C9.00876 5.09316 8.60876 5.52098 7.98267 5.52098Z",
    fill: "#B3B6C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.84ad9a56690c3dac8a20e3bc30eabfc8.svg";
export { ForwardRef as ReactComponent };